import { render, staticRenderFns } from "./newUpload.vue?vue&type=template&id=f955a8e2&scoped=true"
import script from "./newUpload.vue?vue&type=script&lang=js"
export * from "./newUpload.vue?vue&type=script&lang=js"
import style0 from "./newUpload.vue?vue&type=style&index=0&id=f955a8e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f955a8e2",
  null
  
)

export default component.exports